<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>서비스 신청 및 조회</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>AS 안내</p>
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">AS 안내</p>
            <custom-tab></custom-tab>
        </div>
    </v-container>
</template>

<script>
import { ref, onMounted } from "vue";
// import { useStore } from "vuex";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import CustomTab from "@/components/CustomTab.vue";

export default {
    props: {},
    name: "problem-layout",
    components: {
        HomeOutline,
        ChevronRight,
        CustomTab,
    },
    setup() {
        const selectedModel = ref(0);

        onMounted(() => {});

        return {
            selectedModel,
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

.selected {
    color: #00a7e7;
    font-weight: bold;
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
}

#product-list {
    width: 100%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
}

</style>
